/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Practice_Meta_From_PrepInputs */



/**
* | output |
* | --- |
* | "from your preparation of {date}" |
*
* @param {Practice_Meta_From_PrepInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_meta_from_prep = /** @type {((inputs: Practice_Meta_From_PrepInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Meta_From_PrepInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`uit je voorbereiding van ${i?.date}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`issu de votre préparation du ${i?.date}`)
	return /** @type {LocalizedString} */ (`from your preparation of ${i?.date}`)
});